import { Link, useParams } from 'react-router-dom';
import Navbar from '../navigation/Navbar';
import HireTalent from '../app/HireTalent';
import Tips from '../JobHome/Tips';
import Blogs from '../app/Blogs';
import Categories from '../app/Categories';
import Footer from '../../components/app/Footer';
import Ad from "../../images/talent/ad.png";
import JobDesc from '../DailyJobs/JobDesc';
import { Typography } from '@mui/material';
import toList from '../utils/ComponentUtil';
import TalentsAPI from '../Apis/TalentsAPI';
import { useState, useEffect } from 'react';
import TalentTemplate from './TalentTemplate';
import "./Talent.scss";


function TalentDetailsPage() {
    const { talent, talentId } = useParams();
    const [talentDetails, setTalentDetails] = useState({});
    const [similarTalents, setSimilarTalents] = useState([])

    useEffect(() => {
        const { talentDetails, similarTalents } = TalentsAPI.getTalentDetails(talentId);
        setTalentDetails(talentDetails);
        setSimilarTalents(similarTalents);
    }, [talent, talentId]);



    const breadcrumbs = [toList([{ to: "/", child: "Home" }, { to: "/hire-talent/", child: 'Hire Talents' },
    { to: "/hire-talent/" + talent + "?type=" + talentDetails?.category, child: talentDetails?.category || ' ' }], Link)
        , <Typography className="job-page-name">{talentDetails?.name}</Typography>]

    return (
        <>
        <Navbar selected='Find Talents'/>
        <JobDesc name='Google Advertisment' jobImg={Ad} talents={similarTalents} breadcrumbs={breadcrumbs} startPosting={false} render={() => {
            return <TalentTemplate talentDesc={talentDetails}/>
        }}></JobDesc>
        <HireTalent/>
        <Tips/>
        <Blogs></Blogs>
        <Categories></Categories>
        <Footer></Footer>
        </>
    );
}

export default TalentDetailsPage;